let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5GMi")).then(() => parcelRequire('6iG9a'));